import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function EmpowerEmployee() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Empower the Employee</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Cyber Awareness Training</div>
                                <h1 className="prod-hero-title">Empower Your Employees with <span>Cyber Training</span></h1>
                                <p>Empower employees through cybersecurity training to boost awareness, mitigate risks, and strengthen your organization's defenses against evolving cyber threats.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Empower Employee" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Overview */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/empower.jpg')} alt="Cyber Training" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Why Training Matters</div>
                                <h2>Your People Are Your Last Line of Defense</h2>
                                <p>Cybersecurity is the most important issue facing organizations today. With the emergence of ransomware and other cyber attacks, the need for tailored training that helps employees protect themselves, their data and their networks is clear.</p>
                                <p>Choosing the right training solution for your organization can be tough — so let our experts help you design and deploy the perfect program.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4 Benefits */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Training Benefits</div>
                        <h2 className="prod-section-title">Why Invest in <span>Security Awareness?</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Well-trained employees dramatically reduce your organization's attack surface</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-eye"></i></div>
                            <h4>Increase User Awareness</h4>
                            <p>Train employees to recognize and report security threats whether in an email, online, or in a physical setting — turning your workforce into a human firewall.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-server"></i></div>
                            <h4>Free Up IT Resources</h4>
                            <p>Reduce the costs and strain on security and IT teams in managing workstation infections and removing malware — allowing them to focus on strategic initiatives.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-stop-circle"></i></div>
                            <h4>Stop Breaches</h4>
                            <p>Prevent the financial and business impact of breaches caused by employee errors and poor judgment — the leading cause of security incidents in organizations worldwide.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-lock"></i></div>
                            <h4>Protect Data</h4>
                            <p>Ensure employees are aware of data privacy and security, and are motivated to protect personally identifiable information and other sensitive data from exposure.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Interactive Training */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Interactive Training</div>
                        <h2 className="prod-section-title">Designed for <span>Optimal Learning</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Introductory modules averaging ~8 minutes and re-engagement micro modules averaging ~2 minutes</p>
                    </div>
                    <div className="prod-numbered-list">
                        <div className="prod-step-item">
                            <span className="prod-step-num">01</span>
                            <div>
                                <h4>Learning Reinforcement</h4>
                                <p>Key security concepts and learning reinforcement resources such as posters, banners, and nano videos can be mixed and matched to run targeted campaigns on timely threats.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">02</span>
                            <div>
                                <h4>Monitoring &amp; Reporting</h4>
                                <p>The admin portal provides an up-to-date dashboard of user activity. Out-of-the-box reports are available for administrators and executives as PDFs — anytime, anywhere.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">03</span>
                            <div>
                                <h4>Customization &amp; Branding</h4>
                                <p>With multi-tenancy and role-based hierarchical support, partners can manage the entire user experience from provisioning to reporting. Additional consulting services can be packaged and sold with our solution.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Build a Security-Aware Culture?</h3>
                            <p>Let CLOUD MIND design a customized cyber awareness training program for your organization.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
